<div id="loader" *ngIf="loader">
	<span class="spinner-border spinner-grow-lg"></span>
</div>

<div class="modal fade" id="linkEventDialog" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false">
	<div class="modal-dialog modal-lg modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="btn-close" (click)="linkClose()"></button>
			</div>
			<div class="modal-body">
				<div class="container">
					<div class="input-group mb-3">
						<input
							type="text"
							class="form-control"
							name="event2"
							[(ngModel)]="event2"
							placeholder="ID drugiego wydarzenia"
						/>
						<button class="btn btn-primary" type="button" (click)="linkSave()">
							Dodaj nowe połączenie
						</button>
					</div>
					<app-dynamic-table
						module="tourismEventsLink"
						[elements]="data"
						[tableRows]="tableRows"
						[haveLink]="false"
						[haveButton]="true"
						buttonText="X"
						[haveAnyFilters]="false"
						(buttonClicked)="deleteAsk($event)"
					></app-dynamic-table>
				</div>
			</div>
		</div>
	</div>
</div>
